import { getRequest } from "api/axiosClient";
import { GetRateCardListResponseType, GetRateCardResponseType, GetRateCardTemplatesResponseType } from "api/response";

const { REACT_APP_CARGOBASE_BASE_URL } = import.meta.env;
const baseURL = `${REACT_APP_CARGOBASE_BASE_URL}/rate-card`;
const rateCardsBaseURL = `${REACT_APP_CARGOBASE_BASE_URL}/rate-cards`;

const getRateCards = (config = {}) => getRequest<GetRateCardListResponseType>(`${baseURL}s`, config);
const getRateCardDetails = (id: string, config = {}) => getRequest<GetRateCardResponseType>(`${baseURL}/${id}`, config);
const getRateCardTemplates = (config = {}) =>
  getRequest<GetRateCardTemplatesResponseType>(`${rateCardsBaseURL}/templates`, config);

export { getRateCards, getRateCardDetails, getRateCardTemplates };
